import React, { useEffect } from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";
import Documentation from "./Documentation.jsx";
import { useSelector, useDispatch } from "react-redux";
import { updateOverview } from "../../state/reducers/codeOverview";

function CodeDocumentation() {

  const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const showDocumentation = useSelector((state) => state.CodeDocumentation.showDocumentation)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateOverview(false))
  }, [])

  return (
    <>
      {!showOverview && !showDocumentation && <CloneRepo />}
      {showDocumentation && <Documentation />}
    </>
  );
}

export default CodeDocumentation;